import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { TextBox, When } from 'UI/components/atoms';

import { ReasonsCheckboxGroup } from './ReasonsCheckboxGroup';
import { VerticalStack } from './ReasonsSelector.styled';

const { declinationReasons: STRINGS } = strings.sendoutsV2.form.sections;

export const ReasonsSelector = ({
  commentsFieldName = 'comments',
  commentsLabel = STRINGS.commentsLabel,
  commentsPlaceholder = STRINGS.commentsLabel,
  reasons = [],
  reasonsFieldName = 'reasons',
  reasonsValidationMessage = STRINGS.reasonsValidationMessage,
  required = true,
  subtitle = STRINGS.subtitle
}) => {
  const { control, errors, register } = useFormContext();

  const hasError = Boolean(errors[reasonsFieldName]);

  return (
    <VerticalStack>
      <Typography variant="body2">{subtitle}</Typography>

      <FormControl component="fieldset" error={hasError}>
        <Controller
          as={<ReasonsCheckboxGroup reasons={reasons} />}
          control={control}
          defaultValue={[]}
          name={reasonsFieldName}
          rules={{
            validate: value =>
              !required || (Array.isArray(value) && value.length > 0) || reasonsValidationMessage
          }}
        />

        <When condition={hasError}>
          <FormHelperText>{errors[reasonsFieldName]?.message}</FormHelperText>
        </When>
      </FormControl>

      <TextBox
        inputRef={register()}
        label={commentsLabel}
        multiline
        name={commentsFieldName}
        placeholder={commentsPlaceholder}
      />
    </VerticalStack>
  );
};
